export function isValidHttpUrl(maybeUrl: string) {
  let url: URL;

  try {
    url = new URL(maybeUrl);
  } catch (_) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}
